"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLink = exports.Logo = exports.AppPickerWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _Link = _interopRequireDefault(require("../../../core/Link"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const StyledLink = exports.StyledLink = /*#__PURE__*/(0, _base.default)(_Link.default, process.env.NODE_ENV === "production" ? {
  target: "e12msqxg2"
} : {
  target: "e12msqxg2",
  label: "StyledLink"
})(process.env.NODE_ENV === "production" ? {
  name: "7tfrcw",
  styles: "min-height:40px;margin-top:0.5em"
} : {
  name: "7tfrcw",
  styles: "min-height:40px;margin-top:0.5em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Logo = exports.Logo = /*#__PURE__*/(0, _base.default)("img", process.env.NODE_ENV === "production" ? {
  target: "e12msqxg1"
} : {
  target: "e12msqxg1",
  label: "Logo"
})(props => /*#__PURE__*/(0, _react.css)("cursor:pointer;max-height:40px;max-width:", props.small ? '100%' : 'auto', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Logo;")));
const AppPickerWrapper = exports.AppPickerWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e12msqxg0"
} : {
  target: "e12msqxg0",
  label: "AppPickerWrapper"
})("display:flex;justify-content:flex-start;align-items:flex-start;margin-top:40px;min-height:85px;overflow:hidden;@media screen and (max-height: ", _breakpoints.default.heightMedium, "){margin-top:2em;}@media screen and (max-height: ", _breakpoints.default.heightSmall, "){margin-top:1em;}@media screen and (max-width: ", _breakpoints.default.medium, "){padding:2em 2.5em;margin-top:0;align-items:center;justify-content:center;button{margin-bottom:0;}}&>a:nth-of-type(2){margin-left:0.5em;}");